'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTcAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "#07319C" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.3335 9.99998C18.3335 8.90624 18.3335 7.61312 18.3335 6.6658C18.3335 5.92942 18.9305 5.33331 19.6668 5.33331H23.6668C24.4032 5.33331 25.0002 5.92942 25.0002 6.6658C25.0002 7.61313 25.0002 8.90624 25.0002 9.99998C25.0002 13.3333 21.6668 14.6666 21.6668 14.6666C21.6668 14.6666 18.3335 13.3333 18.3335 9.99998Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.0002 9.99998C19.0002 11.4187 19.7025 12.4185 20.4461 13.0878C20.8185 13.4229 21.1931 13.6667 21.4747 13.8262C21.5457 13.8664 21.6103 13.901 21.6668 13.9302C21.7234 13.901 21.788 13.8664 21.859 13.8262C22.1406 13.6667 22.5152 13.4229 22.8875 13.0878C23.6312 12.4185 24.3335 11.4187 24.3335 9.99998V6.6658C24.3335 6.29816 24.0356 5.99998 23.6668 5.99998H19.6668C19.2981 5.99998 19.0002 6.29816 19.0002 6.6658V9.99998ZM18.3335 6.6658V9.99998C18.3335 13.3333 21.6668 14.6666 21.6668 14.6666C21.6668 14.6666 25.0002 13.3333 25.0002 9.99998V6.6658C25.0002 5.92942 24.4032 5.33331 23.6668 5.33331H19.6668C18.9305 5.33331 18.3335 5.92942 18.3335 6.6658Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.0002 9.33329C23.3684 9.33329 23.6668 8.73634 23.6668 7.99996C23.6668 7.26358 23.3684 6.66663 23.0002 6.66663C22.632 6.66663 22.3335 7.26358 22.3335 7.99996C22.3335 8.73634 22.632 9.33329 23.0002 9.33329Z",
          fill: "#BA5B1F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.5385 9.29312C20.8845 9.16719 20.9608 8.50416 20.709 7.81219C20.4571 7.12021 19.9724 6.66135 19.6265 6.78728C19.2805 6.9132 19.2042 7.57624 19.456 8.26821C19.7079 8.96018 20.1925 9.41905 20.5385 9.29312Z",
          fill: "#FF9F3E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.052 9.27086C20.3857 9.42647 20.9085 9.01158 21.2197 8.3442C21.5309 7.67681 21.5127 7.00964 21.179 6.85404C20.8453 6.69844 20.3225 7.11332 20.0113 7.78071C19.7001 8.44809 19.7183 9.11526 20.052 9.27086Z",
          fill: "#FF937F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 10.6666L21.6667 9.33331L22.3333 10.6666V12H21V10.6666Z",
          fill: "#01A827"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagTcAsset = forwardRef(FlagTcAsset);

export { VpFlagTcAsset as default };
